import styled from 'styled-components';
import { fontBody } from 'Styles/fonts';

export const ProductShippingGuidance = styled.div`
  color: var(--foreground);
  border-top: 1px solid var(--border);
  margin-top: 16px;
  ${fontBody(16)}
  & input {
    border-radius: 4px;
  }
  & button {
    border-radius: 3px;
  }
`;

export default {};
